// STUB scaffold: versão slim do EditPermissionsContext.
// O original (frontend/) abre um EditPermissionsModal do módulo `usuario`
// (permissões do backoffice) — que NÃO foi portado para o portal. Aqui
// `openEditModal` é no-op. O nav-section só chama isso quando o "modo gestor"
// está ligado (isGestorMode), que fica desligado por padrão no portal.
import type { ReactNode } from 'react';

import { useMemo, useContext, useCallback, createContext } from 'react';

interface EditPermissionsContextProps {
  openEditModal: (menuTitle: string, menuPath?: string) => void;
}

const EditPermissionsContext = createContext<EditPermissionsContextProps | undefined>(undefined);

interface EditPermissionsProviderProps {
  children: ReactNode;
}

export function EditPermissionsProvider({ children }: EditPermissionsProviderProps) {
  const openEditModal = useCallback((_menuTitle: string, _menuPath?: string) => {
    // no-op no portal
  }, []);

  const value = useMemo(() => ({ openEditModal }), [openEditModal]);

  return (
    <EditPermissionsContext.Provider value={value}>{children}</EditPermissionsContext.Provider>
  );
}

export function useEditPermissions() {
  const context = useContext(EditPermissionsContext);
  if (!context) {
    throw new Error('useEditPermissions deve ser usado dentro de EditPermissionsProvider');
  }
  return context;
}
